export default __webpack_public_path__ + "static/media/metavers4.84c6650c.jpg";